/**
 * version: 1.0.0
 * author: John Bandy, john@concatsys.com
 * company: Concat Systems, Inc.
 *
 * copyright 2020 Concat Systems, Inc.
 *
 * {@link https://github.com/ConcatSystems/ConcatJS}
 */


//------------------------------------------------------------------------------
/**
 * Pads a stringified number with leader zeros for padding 
 * @param  {Number} n The number to pad
 * @param  {Number} s The number of places to pad (defaults to two)
 * @return {string}   The stringified number w/ padding
 */
const Pad = ( n, s = 2 ) => 
  {
    let a = String( n );
    while( a.length < s ) { a = "0" + a; }
    return( a );
  };


export { Pad };